import React from 'react'

import { ITransactionListItem } from 'services/api/ProfileApi/types/types'

import { ROUTE_PATHS, ROUTE_URLS } from 'router/routes'

import { LocaleProfileKeysType } from 'shared/locale/en-US'
import { BonusPromotionStatus } from 'shared/models/Promotion'
import { UpgamingSportPages } from 'shared/models/Upgaming'
import { UserTypes } from 'shared/models/User'

const SlotsHistoryPage = React.lazy(() => import('../pages/SlotsHistoryPage'))
const SpinHistoryPage = React.lazy(() => import('../pages/SpinHistoryPage'))
const ChangePasswordPage = React.lazy(() => import('../pages/ChangePasswordPage'))
const TransactionsPage = React.lazy(() => import('../pages/TransactionsPage'))
const ExchangeBonusPage = React.lazy(() => import('../pages/ExchangeBonusPage'))
const UserInfoPage = React.lazy(() => import('../pages/UserInfoPage'))
const BonusPromotionsPage = React.lazy(() => import('../pages/BonusPromotionsPage'))
const KycVerificationPage = React.lazy(() => import('../pages/KycVerificationPage'))

export type IProfileMenuTab = {
  textId: LocaleProfileKeysType
  route: string
  Component?: any
  isMenu?: boolean
  acceptedUserTypes?: UserTypes[]
}

export const ProfileMenuTabs: IProfileMenuTab[] = [
  {
    textId: 'personalInformation',
    route: ROUTE_URLS.PROFILE_USERINFO(),
    Component: UserInfoPage,
  },
  {
    textId: 'betHistory',
    route: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.BET_HISTORY),
  },
  {
    textId: 'transactions',
    route: ROUTE_URLS.PROFILE_TRANSACTIONS(),
    Component: TransactionsPage,
  },
  {
    textId: 'slotsHistory',
    route: ROUTE_URLS.PROFILE_SLOTS_HISTORY(),
    Component: SlotsHistoryPage,
  },
  // {
  //   textId: 'spinHistory',
  //   route: ROUTE_URLS.PROFILE_SPIN_HISTORY(),
  //   Component: SpinHistoryPage,
  // },
  {
    textId: 'exchangeBonus',
    route: ROUTE_URLS.PROFILE_EXCHANGE_BONUS_BALANCE(),
    Component: ExchangeBonusPage,
  },
  {
    textId: 'changePassword',
    route: ROUTE_URLS.PROFILE_CHANGE_PASSWORD(),
    Component: ChangePasswordPage,
  },
  {
    textId: 'promotions',
    route: ROUTE_URLS.PROFILE_PROMOTIONS_STATUS(BonusPromotionStatus.active),
    Component: BonusPromotionsPage,
  },
  {
    textId: 'promotions',
    route: ROUTE_URLS.PROFILE_PROMOTIONS_STATUS(BonusPromotionStatus.available),
    Component: BonusPromotionsPage,
  },
  {
    textId: 'promotions',
    route: ROUTE_URLS.PROFILE_PROMOTIONS_STATUS(BonusPromotionStatus.completed),
    Component: BonusPromotionsPage,
  },
  {
    textId: 'promotions',
    route: ROUTE_URLS.PROFILE_PROMOTIONS_STATUS(BonusPromotionStatus.expired),
    Component: BonusPromotionsPage,
  },
  {
    textId: 'kycVerification',
    route: ROUTE_PATHS.PROFILE_KYC_VERIFICATION,
    Component: KycVerificationPage,
  },
]

export const profileLinks: IProfileMenuTab[] = [
  {
    textId: 'personalInformation',
    route: ROUTE_URLS.PROFILE_USERINFO(),
    Component: UserInfoPage,
  },
  {
    textId: 'betHistory',
    route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('BetsHistory'),
  },
  {
    textId: 'transactions',
    route: ROUTE_URLS.PROFILE_TRANSACTIONS(),
    Component: TransactionsPage,
  },
  {
    textId: 'slotsHistory',
    route: ROUTE_URLS.PROFILE_SLOTS_HISTORY(),
    Component: SlotsHistoryPage,
  },
  // {
  //   textId: 'spinHistory',
  //   route: ROUTE_URLS.PROFILE_SPIN_HISTORY(),
  //   Component: SpinHistoryPage,
  // },
  {
    textId: 'exchangeBonus',
    route: ROUTE_URLS.PROFILE_EXCHANGE_BONUS_BALANCE(),
    Component: ExchangeBonusPage,
  },
  {
    textId: 'changePassword',
    route: ROUTE_URLS.PROFILE_CHANGE_PASSWORD(),
    Component: ChangePasswordPage,
  },
  {
    textId: 'kyc',
    route: ROUTE_URLS.PROFILE_KYC_VERIFICATION(),
    Component: KycVerificationPage,
  },
  {
    textId: 'promotions',
    route: ROUTE_URLS.PROFILE_PROMOTIONS_STATUS(BonusPromotionStatus.active),
    Component: BonusPromotionsPage,
  },
]

export const PayHistoryDateFormat = 'YYYY-MM-DD'

export const getBalance = (transaction?: ITransactionListItem | null, userId?: number) => {
  if (!transaction || !userId) return { beforeBalance: 0, afterBalance: 0 }

  const userIsSender = userId === transaction.fromId
  const beforeBalance = +(userIsSender ? transaction?.senderBalanceBefore : transaction?.recipientBalanceBefore) || 0
  const afterBalance = +(userIsSender ? transaction?.senderBalanceAfter : transaction?.recipientBalanceAfter) || 0

  return { beforeBalance, afterBalance }
}

export const RECOMMEND_PAYMENTS = [
  'attjariwafa_bank_card',
  'bank_of_africa_card',
  'ibanka_lik_card',
  'cdm_card',
  'cash_plus_card',
  'cih_bank_card',
  'bank-e_card',
  'societe_generale_card',
  'cfg_bank_card',
]

export const E_WALLETS_PAYMENTS = ['bank_of_africa_card']

export const BANK_TRANSFER = [
  'attjariwafa_bank_card',
  'cdm_card',
  'cash_plus_card',
  'bank-e_card',
  'cfg_bank_card',
  'societe_generale_card',
]

export const PAYMENT_CATEGORIES = [
  {
    title: 'profile.depositPage.eWallets',
    slugs: E_WALLETS_PAYMENTS,
  },
  {
    title: 'profile.depositPage.bankTransfer',
    slugs: BANK_TRANSFER,
  },
]

export * from './descriptionBlock'
export * from './icons'
export * from './info'
export * from './templateAmount'
export * from './utils'
